import GATSBY_COMPILED_MDX from "/opt/build/repo/content/projects/miga.mdx";
import React from 'react';
import Helmet from 'react-helmet';
import {graphql} from 'gatsby';
import Card from '../components/Card';
import Layout from '../layout';
import {Link} from 'gatsby';
import config from '../../data/SiteConfig';
import Hero from '../components/Project/Hero';
import HeroImage from '../components/Category/HeroImage';
import HeroScroll from '../components/HeroScroll';
import './project.scss';
import TechnicalSpecs from '../components/Project/TechnicalSpecs';
import ImageLightBox from '../components/imageLightBox/imageLightBox';
import PageCallout from '../components/PageCallout';
import ConsiderReading from '../components/ConsiderReading';
import Interrupt from '../components/Project/Interrupt';
import {MDXProvider} from '@mdx-js/react';
import ProgressBar from '../components/ProgressBar/ProgressBar';
import * as ReactDOM from 'react-dom';
import ProjectExample from '../components/ProjectExample';
import _ from 'lodash';
class ProjectTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: true,
      medium: false,
      headerOffSet: 0,
      postBodyHeight: 0,
      showLightBox: undefined,
      images: [],
      photoIndex: 0
    };
    this.handleResize = this.handleResize.bind(this);
    this.setOpen = this.setOpen.bind(this);
  }
  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize() {
    if (window.innerWidth >= 640) {
      this.setState({
        mobile: false,
        medium: false
      });
      if (window.innerWidth <= 992) {
        this.setState({
          medium: true,
          mobile: false
        });
      }
    } else {
      this.setState({
        mobile: true,
        medium: false
      });
    }
  }
  componentDidUpdate() {
    const node = ReactDOM.findDOMNode(this);
    if (node instanceof HTMLElement) {
      const child = node.querySelector('.project-body');
      const images = [];
      let modifiedI = 0;
      node.querySelectorAll('.project-body img').forEach((x, i) => {
        if (x.parentNode.className.includes('lightboxIgnore') || x.parentElement.nodeName == 'PICTURE') {
          modifiedI++;
        } else {
          images.push(x.src);
          let index = modifiedI > 0 ? i - modifiedI : i;
          x.onclick = () => this.setOpen(true, index);
        }
      });
      if (!_.isEqual(this.state.images, images)) {
        this.setState({
          images
        });
      }
      const headerOffSet = window.pageYOffset + child.getBoundingClientRect().top;
      const postBodyHeight = child.offsetHeight;
      if (this.state.headerOffSet !== headerOffSet || this.state.postBodyHeight !== postBodyHeight) {
        this.setState({
          headerOffSet,
          postBodyHeight
        });
      }
    }
  }
  setOpen(open, i) {
    this.setState({
      showLightBox: open,
      photoIndex: i
    });
  }
  render() {
    const {slug} = this.props.pageContext;
    const projectNode = this.props.data.mdx;
    const project = projectNode.frontmatter;
    const shortcodes = {
      ConsiderReading,
      Interrupt
    };
    if (!projectNode.id) {
      projectNode.id = slug;
    }
    return React.createElement(Layout, {
      location: this.props.location,
      title: "project.title",
      hero: React.createElement(Hero, {
        project: project
      }),
      heroImage: React.createElement(HeroImage, {
        imageUrl: project.hero_image.url
      }),
      heroType: "",
      alignLeft: true,
      scroll: React.createElement(HeroScroll)
    }, project.layout === 'case-study' ? React.createElement(ProgressBar, {
      typeIcon: "fa-list",
      type: "Case Study",
      title: project.title,
      subtitle: project.client,
      headerOffSet: this.state.headerOffSet,
      postBodyHeight: this.state.postBodyHeight,
      toTop: "false"
    }) : React.createElement(ProgressBar, {
      typeIcon: "fa-bookmark-o",
      type: "Project",
      title: project.title,
      subtitle: project.client,
      headerOffSet: this.state.headerOffSet,
      postBodyHeight: this.state.postBodyHeight,
      toTop: "false"
    }), React.createElement("div", {
      className: "project-page"
    }, React.createElement(Helmet, null, React.createElement("title", null, `${project.title} | ${config.siteTitle}`), React.createElement("link", {
      rel: "canonical",
      href: `${config.siteUrl}${projectNode.id}`
    })), React.createElement(ImageLightBox, {
      photoIndex: this.state.photoIndex,
      images: this.state.images,
      isOpen: this.state.showLightBox,
      setOpen: this.setOpen
    }), React.createElement("div", {
      className: `project-page-contents`
    }, React.createElement(Card, null, project.layout === 'case-study' ? React.createElement("div", {
      className: `project-body project-body--inner`
    }, React.createElement(MDXProvider, {
      components: shortcodes
    }, this.props.children), React.createElement(TechnicalSpecs, {
      services: project.services
    })) : React.createElement("div", {
      className: `project-body project-body--inner-full grid grid-columns`
    }, React.createElement("section", {
      className: "width-12/12@sm width-6/12"
    }, React.createElement(MDXProvider, {
      components: shortcodes
    }, this.props.children), React.createElement(TechnicalSpecs, {
      services: project.services
    })), React.createElement("section", {
      className: "width-12/12@sm width-6/12"
    }, project.mobile_image.url ? React.createElement(ProjectExample, {
      imageUrl: project.mobile_image.url,
      alt: project.mobile_image.alt
    }) : null, project.desktop_image.url ? React.createElement(ProjectExample, {
      imageUrl: project.desktop_image.url,
      alt: project.desktop_image.alt
    }) : null))))), React.createElement(PageCallout, null, React.createElement("div", null, React.createElement("div", null, React.createElement("h4", null, "Let's work together"), React.createElement("p", null, "Nothing Beats a face-to-face meeting. We'll come to your office, or you can meet us at one of ours."), React.createElement(Link, {
      className: "button outline large",
      to: '/contact'
    }, "Contact Us"), ' ', React.createElement("br"), React.createElement(Link, {
      to: '/portfolio'
    }, "See more examples of our work", ' ', React.createElement("i", {
      className: "fa fa-caret-right",
      "aria-hidden": "true"
    }))))));
  }
}
export const pageQuery = graphql`
  query ProjectBySlug($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      id
      fields {
        slug
      }
      frontmatter {
        title
        description
        project_description
        client
        layout
        header_layout
        website
        services {
          angular
          chef
          drupal
          jekyll
          symfony
        }
        hero_image {
          url
        }
        cover_image {
          url
        }
        header_image {
          url
        }
        desktop_image {
          url
          alt
          title
        }
        mobile_image {
          url
          alt
          title
        }
      }
    }
  }
`;
ProjectTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ProjectTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
